import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition, EditionInfo } from '../../../models';

class DocumentationContentController implements angular.IComponentController {
    formController: angular.IFormController;
    isEditMode: boolean = false;
    isLoading: boolean;
    item: any;

    readonly applicationGuid?: string;
    readonly category: string;
    readonly editionInfo: EditionInfo;
    readonly hasEditRole: boolean;
    readonly onSave: () => void;

    private _original: any;

    static $inject = ['$state'];

    constructor(private _$state: StateService) {
    }

    edit(): void {
        this.isEditMode = true;
        this._original = angular.copy(this.item);
    }

    save(): void {
        this.isEditMode = false;
        this.formController.$setPristine();
        this.onSave();
    }

    cancel(): void {
        this.isEditMode = false;
        this.item = angular.copy(this._original);
        this.formController.$setPristine();
        this._original = undefined;
    }

    redirect(value: { url: string; params: any }) {
        if (value) {
            this._$state.go(value.url, value.params);
        }
    }

}

export const wtDocumentationContent: ComponentDefinition = {
    componentId: 'wtDocumentationContent',
    controller: DocumentationContentController,
    controllerAs: 'vm',
    template: require('./documentationContent.component.html'),
    bindings: {
        applicationGuid: '<?',
        category: '@',
        editionInfo: '<',
        hasEditRole: '<',
        isEditMode: '=?',
        item: '=',
        onSave: '&'
    }
};